// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"lW-z","inlineTitle":"mW-z","sponsoredAdsWrapper":"nW-z","marketplaceRecosWrapper":"oW-z"};